import { Component, Input, OnInit } from '@angular/core';
import { AggregatedJobData, Job } from '@shared';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Elevations } from 'mojo-card';
import { AvatarBackgroundSizes, AvatarShapes } from 'mojo-avatar';
import { selectAggregatedTotalDirectPerPhasesForGivenJobId } from '@modules/reports/store/referral-reports.selectors';

@Component({
  selector: 'mojo-pipeline-job-item',
  templateUrl: './pipeline-job-item.component.html',
})
export class PipelineJobItemComponent implements OnInit {
  @Input() jobItem: Job;
  @Input() aggregatedJobData: AggregatedJobData;

  avatarPhotoShape = AvatarShapes.circle;
  avatarBackgroundSizes = AvatarBackgroundSizes.cover;
  elevation = Elevations.first;

  jobTotalDirectPerPhases$: Observable<any>;

  constructor(private store: Store<{}>) {}

  ngOnInit() {
    this.jobTotalDirectPerPhases$ = this.store.select(
      selectAggregatedTotalDirectPerPhasesForGivenJobId(this.jobItem.id),
    );
  }
}
